export { QuestionMarkCircle as default } from './QuestionMarkCircle';
